import type { CSSProperties } from 'react';

/**
 * Material Symbols Rounded glyph (self-hosted via the material-symbols
 * package). Defaults — wght 300, opsz 20, 20px — come from tokens.css; size
 * and color are the common per-use overrides.
 */
export type MaterialSymbolProps = {
  name: string;
  size?: number;
  color?: string;
  filled?: boolean;
  style?: CSSProperties;
  className?: string;
  /** Lets a glyph be asserted in tests without selecting on its CSS class. */
  automationId?: string;
};

export const MaterialSymbol = ({
  name,
  size,
  color,
  filled = false,
  style,
  className,
  automationId,
}: MaterialSymbolProps) => (
  <span
    aria-hidden
    data-automation-id={automationId}
    className={className ? `material-symbols-rounded ${className}` : 'material-symbols-rounded'}
    style={{
      ...(size !== undefined ? { fontSize: size } : {}),
      ...(color !== undefined ? { color } : {}),
      ...(filled ? { fontVariationSettings: "'FILL' 1, 'wght' 300, 'GRAD' 0, 'opsz' 20" } : {}),
      ...style,
    }}
  >
    {name}
  </span>
);
